module.exports = __webpack_public_path__ + "img/MaleAvatar.fc098ace.png";